import { render, staticRenderFns } from "./english.vue?vue&type=template&id=436e0c69&scoped=true&"
import script from "./english.vue?vue&type=script&lang=js&"
export * from "./english.vue?vue&type=script&lang=js&"
import style0 from "./english.vue?vue&type=style&index=0&id=436e0c69&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "436e0c69",
  null
  
)

export default component.exports